import { redisGetHandler } from "../utils/redis";

export default (axios, config) => ({
  // Где вызывается: сервер.
  async getServicesNew(Redis, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      "/services/getServicesNew",
      reset,
    );
  },
  // Где вызывается: сервер.
  async getServices(Redis, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      "/services/getServices",
      reset,
    );
  },
  // Где вызывается: сервер.
  async getServicesInstall(Redis, code, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      `/services/getServicesInstall?code=${code}`,
      reset,
    );
  },
});
